import moment from "moment"

export const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/ricm/"
export const IMAGE_BASE_NAME_FORMAT = "YYYYMMDD"
export const DATE_FORMAT_TO_DISPLAY = "DD/MM/YYYY"
export const INTERVAL_IMAGES = [1, "days"]
export const MAX_DATE_INTERVAL = [7, 'days']
export const MIN_DATE = moment().subtract(10, "minutes")
